// extracted by mini-css-extract-plugin
export default {"legends":"styles_legends__Z13t0","label":"styles_label__YvYrw"};